package com.shadowings.gero.util

import androidx.compose.runtime.Composable

const val FEEDBACK_EMAIL_ADDRESS = "shadowingsproteam@gmail.com"

enum class FeedbackType {
    GENERAL,
    UPDATE_ISSUE,
    QUIZ_ERROR,
    MORE_LESSONS
}

data class FeedbackEmail(
    val subject: String,
    val templateBody: String,
    val debugInfo: String
)

/**
 * Sends a feedback email. Where the platform can launch a real mail-app chooser (Android),
 * [FeedbackEmail.debugInfo] is attached as a .txt file instead of being appended to the body,
 * since a bare `mailto:` link (used elsewhere) has no attachment mechanism.
 */
@Composable
expect fun rememberFeedbackSender(): (FeedbackEmail) -> Unit
